import "nodelist-foreach-polyfill";

const triggers = document.querySelectorAll<HTMLElement>(".js-event-log");
const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || null;

if (csrfToken !== null) {
  triggers.forEach((ele) => {
    ele.addEventListener("click", () => {
      fetch("/event_logs", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify({ event_name: ele.dataset.event, referrer: ele.dataset.referrer }),
        credentials: "same-origin",
      }).catch((error) => console.error(error));
    });
  });
}
